module.exports = __webpack_public_path__ + "static/media/logo.be3031ad.png";